import { useMutation } from '@tanstack/react-query';
import { getStructure } from '../api/client';

export const useGetStructure = () => {
  const { mutateAsync: fetchStructure, isPending, isError } = useMutation({
    mutationFn: (cart: any) => getStructure({ shoppingCart: cart }),
  });

  return { fetchStructure, isPending, isError };
};